import { ReportCategory, type ReportCategoryValue } from "@pages/QASettings/constants";
import { ReportType } from "@pages/Templates/constants";

const ABA_REPORT_TYPES = [ReportType.INITIAL_ASSESSMENT, ReportType.REASSESSMENT];

export const reportCategoryFromTypes = (reportTypes: string[]): ReportCategoryValue =>
  reportTypes.includes(ReportType.DIAGNOSIS_EVALUATION) ? ReportCategory.DIAGNOSIS : ReportCategory.ABA;

export const reportTypesFromCategory = (cat: ReportCategoryValue): string[] =>
  cat === ReportCategory.DIAGNOSIS ? [ReportType.DIAGNOSIS_EVALUATION] : [...ABA_REPORT_TYPES];
